import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {SelectFilterElement} from '../../../../../../../components/common/select-filter/select-filter.model';
import {Operator, UrlParameter} from '../../../../../../../shared/utils/url.builder';
import {NewItemModalOptions} from '../../../../../../core/component/select/abstract-select.component';
import {MedicalRecordProblemModel} from '../../model/medicalRecordProblem.model';
import {StringUtils} from '../../../../../../../shared/utils/string.utils';
import {
    MedicalProblemSaveDialogInput,
    MedicalProblemSaveDialogResult, MedicalRecordProblemCreateUpdateComponent
} from '../medical-record-problem-create-update/medical-record-problem-create-update.component';
import {MedicalProblemFindAllService} from '../../../impl/service/medicalProblemFindAll.service';
import {ConsultationSummaryModel} from '../../../../../consultation/consultation/api/model/consultationSummary.model';

@Component({
    selector: 'app-medical-record-problem-multiple-select-filter',
    templateUrl: './medical-record-problem-multiple-select-filter.component.html',
    providers: [
        MedicalProblemFindAllService
    ]
})
export class MedicalRecordProblemMultipleSelectFilterComponent implements OnChanges {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() noEntriesFoundLabel = 'Aucun problème trouvé';
    @Input() parentFormControlName: string;
    @Input() partnerId: number;
    @Input() consultationSummary: ConsultationSummaryModel;

    additionalUrlParameters: UrlParameter[] = [];

    constructor(public service: MedicalProblemFindAllService) {}


    resolveSelectFilterElement = (entity: MedicalRecordProblemModel): SelectFilterElement<string | number, MedicalRecordProblemModel> => {
        return new SelectFilterElement(entity.id, entity.id, entity);
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log(['partnerId', this.partnerId]);
        if (changes['partnerId']) {
            this.additionalUrlParameters = [new UrlParameter('partner.id', this.partnerId, Operator.EQUALS)];
        }
    }

    filter = (criteria: string, entity: MedicalRecordProblemModel) => {
        return entity.toString().toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    newProblemModalOptions():
        NewItemModalOptions<
            MedicalProblemSaveDialogResult,
            MedicalProblemSaveDialogInput,
            MedicalRecordProblemCreateUpdateComponent> {
        const input: MedicalProblemSaveDialogInput = {
            partnerId: this.consultationSummary ? undefined : this.partnerId,
            consultationSummary: this.consultationSummary
        };
        return {
            dialogOption: {
                title: 'Créer un problème'
            },
            componentType: MedicalRecordProblemCreateUpdateComponent,
            dialogInput: input,
            valueNewItemMapper: this.valueNewItemMapper
        };
    }

    valueNewItemMapper = (result: MedicalProblemSaveDialogResult) => {
        console.log(['New value', result]);
        return result?.entity?.id;
    }

    format(entity: MedicalRecordProblemModel): string {
        let label = '<strong>' + entity.type?.label + '</strong> (' + entity.type?.parentLabel + ')';
        if (entity.description) {
            label += ' ' + StringUtils.removeHtml(entity.description);
        }
        return label;
    }
}
